import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StatefulService } from '@app/service/stateful.service';
import { AssetAllocation } from '@workflow/ecp-workflow/dynamic-app/component/building-block/asset-allocation/asset-allocation.models';
import { WorkflowService } from '@workflow/service/workflow/workflow.service';

const BeneficiaryType = { primary: 'Primary', contingent: 'Contingent' };
const BENEFICIARY = 'api:oaoMemberInformation/beneficiary';
const ALLOCATIONSTGID = 'api:oaoMemberInformation/beneficiary/$/allocationPercent';
const BENEFICIARYTYPESTGID = 'api:oaoMemberInformation/beneficiary/$/allocationType';
const PRIMARY = 'primary';
const CONTINGENT = 'contingent';
/** Const Variable for Beneficiary Page Id */
const BENEFICIARY_PAGE_ID = 'beneficiary';

/**
 * different type of field layout
 */
@Component({
  selector: 'ecp-oao-beneficiary-review',
  templateUrl: './oao-beneficiary-review.component.html'
})
export class OaoBeneficiaryReviewComponent implements OnInit {
  private readonly statefulService = inject(StatefulService);

  /** Primary Beneficiary List */
  public primaryBeneficiaryList: AssetAllocation[] = [];
  /** Contingent Beneficiary List */
  public contigentBeneficiaryList: AssetAllocation[] = [];

  constructor(public readonly router: Router, public readonly workflowService: WorkflowService) {}

  /** Init */
  public ngOnInit(): void {
    this.setItemValues();
  }

  /** Check Card Type */
  public checkCardType(fieldId, allocationType): boolean {
    switch (fieldId) {
      case 'oao-beneficiary-primary-allocation':
        return allocationType === BeneficiaryType.primary;
      case 'oao-beneficiary-contingent-allocation':
        return allocationType === BeneficiaryType.contingent;
    }
  }

  /** Set Item Values */
  private setItemValues(): void {
    const allSize = this.statefulService.arraySize(BENEFICIARY);

    for (let i = 0; i < allSize; i++) {
      const allocationType = this.statefulService.wrap(BENEFICIARYTYPESTGID, i).valueStringOnly;
      if (allocationType) {
        if (allocationType.toLowerCase() === PRIMARY) {
          this.primaryBeneficiaryList.push({
            acutalIndex: i,
            allocation: {
              storageId: ALLOCATIONSTGID,
              value: this.statefulService.wrap(ALLOCATIONSTGID, i).valueStringOnly
            },
            type: {
              storageId: BENEFICIARYTYPESTGID,
              value: this.statefulService.wrap(BENEFICIARYTYPESTGID, i).valueStringOnly
            }
          });
        }
        if (allocationType.toLowerCase() === CONTINGENT) {
          this.contigentBeneficiaryList.push({
            acutalIndex: i,
            allocation: {
              storageId: ALLOCATIONSTGID,
              value: this.statefulService.wrap(ALLOCATIONSTGID, i).valueStringOnly
            },
            type: {
              storageId: BENEFICIARYTYPESTGID,
              value: this.statefulService.wrap(BENEFICIARYTYPESTGID, i).valueStringOnly
            }
          });
        }
      }
    }
  }

  public redirectToEdit() {
    this.router.navigate([`${this.workflowService.currentFlow.id}/${BENEFICIARY_PAGE_ID}`]);
  }
}
